import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AngularPlugin } from '@microsoft/applicationinsights-angularplugin-js';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ClickAnalyticsPlugin } from '@microsoft/applicationinsights-clickanalytics-js';
import { environment } from "../../environments/environment";
import {UserService} from "../data/user/user.service";

@Injectable({
    providedIn: 'root'
})
export class UserTrackingService {
    private appInsights: ApplicationInsights;
   
    constructor(private router: Router, 
        private userService: UserService) {
    }

    public init(): void {
       
        if(!environment.appInsightsConnString)
        {
            return;
        }
        // the angular plugin will automatically log PageViews and Dependencies (any API call)
        const angularPlugin = new AngularPlugin();
        const clickPluginInstance = new ClickAnalyticsPlugin();

        // Click Analytics configuration
        const clickPluginConfig = {
            autoCapture: true
        };

        this.appInsights = new ApplicationInsights({
            config: {
                connectionString: `${environment.appInsightsConnString}`,
                extensions: [angularPlugin, clickPluginInstance],
                extensionConfig: {
                    [angularPlugin.identifier]: { router: this.router },
                    [clickPluginInstance.identifier]: clickPluginConfig
                },
            }
        });

        this.appInsights.loadAppInsights();
        this.appInsights.trackPageView();
        
        this.userService.captureUserDetails()
            .subscribe({
                next: (userId) => {
                    // this inserts the userId to the user_AuthenticatedId field
                    if (userId)
                        this.appInsights.context.user.authenticatedId = userId;
                }
            });
        }
}
